import { render, staticRenderFns } from "./EximMasterFreightUpload.vue?vue&type=template&id=a07b9878&scoped=true&"
import script from "./EximMasterFreightUpload.vue?vue&type=script&lang=js&"
export * from "./EximMasterFreightUpload.vue?vue&type=script&lang=js&"
import style0 from "./EximMasterFreightUpload.vue?vue&type=style&index=0&id=a07b9878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07b9878",
  null
  
)

export default component.exports